import React, { Component } from 'react';
import { PageTitleFragment } from 'constants.js';

import styles from './styles.module.scss'
class NotFound extends Component {
  componentDidMount() {
    document.title = `Page Not Found ${PageTitleFragment}`;
    // this.pageHeading.focus();
  }

  render () {
    return (
      <div className={styles.homePage__container}>
        <div className={styles.homePage}>
          Not Found
        </div>
      </div>
    );
  }
}

export default NotFound;
